import developmentContainer from "src/dependencies/_development";

const container = developmentContainer.createChild({
  defaultScope: "Singleton",
});

export default container;
